/*
*
* File JS per la Homepage
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';

//--------------------------------------------------------------------//

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import blockHeroHp from 'components/block-hero-hp/block-hero-hp';
import blockTitleText from 'components/block-title-text/block-title-text';
import blocksImgText from 'components/blocks-img-text/blocks-img-text';
import blockDemo from 'components/block-demo/block-demo';
import blockProductPlan from 'components/block-product-plan/block-product-plan';
import form from 'components/form/form';
import accordion from 'imComponents/accordion/accordion';
import blockContactForm from 'components/block-contact-form/block-contact-form';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './homepage.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockDemo();
blockProductPlan();
accordion();

//--------------------------------------------------------------------//


// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

const setActiveClass = (id) => {
    let allScrollLi = document.querySelectorAll('.main-menu li.scroll-to');

    allScrollLi.forEach(el => {
        el.classList.remove('active');
    });

    let anchorToActive = document.querySelectorAll('.main-menu li.scroll-to [href="#'+id+'"]')[0];

    if (!anchorToActive) return;

    anchorToActive.parentNode.classList.add('active');
}

const landingSectionScroll = () => {
    let controller = new ScrollMagic.Controller();
    let allSectionAnimate = document.querySelectorAll('.section-anchor');

    if (!allSectionAnimate) return;

    allSectionAnimate.forEach(el => {
        new ScrollMagic.Scene({
            triggerElement: el,
            duration: el.offsetHeight,
            offset: 0,
            triggerHook: 0.5,
            reverse: true,
        })
        // .addIndicators()
        .on('enter', () => {
            setActiveClass(el.id);
        })
        .addTo(controller);
    });
}
landingSectionScroll();

//--------------------------------------------------------------------//